import Yup from "../../utils/yupExtensions";

const NswVoucherRedeemSchema = Yup.object().shape({
  voucherCode: Yup.string().required("Required").lengthCheck(5, 100),
});

export default NswVoucherRedeemSchema;
